import { createSelector } from 'reselect';
import { createSlice } from "@reduxjs/toolkit";

// État initial
const initialState = {};

// Définition du slice
const formValidationSlice = createSlice({
  name: "formValidation",
  initialState,
  reducers: {
    setFieldValue: (state, action) => {
      const { field, value } = action.payload;
      if (!state[field]) {
        state[field] = { value: null, error: "" };
      }
      state[field].value = value;

      // Validation logic can be added here
      if (value && value.name) {
        state[field].error = ""; // Clear error if value is valid
      } else {
        state[field].error = "Invalid value"; // Set error if value is invalid
      }
    },
    setFieldError: (state, action) => {
      const { field, error } = action.payload;
      if (!state[field]) {
        state[field] = { value: null, error: "" };
      }
      state[field].error = error;
    },
    resetFieldState: (state, action) => {
      const { field } = action.payload;
      state[field] = { value: null, error: "" };
    },
  },
});

// Exportation des actions
export const { setFieldValue, setFieldError, resetFieldState } = formValidationSlice.actions;

// Utilisation de createSelector pour rendre le sélecteur performant
export const selectFieldState = createSelector(
  (state, fieldName) => state.formValidation[fieldName], // Extrait la valeur du champ de l'état
  (fieldState) => fieldState || { value: null, error: "" } // Retourne une valeur de secours si le champ est inexistant
);

// Export du reducer
export default formValidationSlice.reducer;